export function firstTrackWithSrc(player) {
  const tracks = player.remoteTextTracks();
  for (var i = 0; i < tracks.length; i++) {
    if (tracks[i].src) {
      return tracks[i];
    }
  }
}
